import { useT } from "../i18n/LanguageContext";

export const LanguageSwitcher = ({ className = "" }) => {
  const { lang, setLang } = useT();
  return (
    <div
      data-testid="language-switcher"
      className={`inline-flex items-center rounded-full border border-[var(--al-line)] bg-white p-0.5 text-[12px] font-display font-semibold ${className}`}
    >
      {["de", "en"].map((code) => (
        <button
          key={code}
          onClick={() => setLang(code)}
          data-testid={`lang-btn-${code}`}
          className={`px-3 py-1.5 rounded-full transition-colors ${
            lang === code ? "al-grad-bg text-white shadow-sm" : "text-slate-500 hover:text-slate-900"
          }`}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
};
